import { utils } from '../../common';

//create types
export default {
  UPDATE_INTERCOM_UNREAD_CONVERSATION: 'UPDATE_INTERCOM_UNREAD_CONVERSATION'
};
